import { Button, ButtonProps } from '@mui/material';
import { ArrowLeft } from 'modules/common/icons';
import { Link } from 'react-router-dom';

interface IBackBtnProps extends ButtonProps {
  to: string;
  label: string;
}

export const BackBtn = ({ to, label, ...rest }: IBackBtnProps) => {
  return (
    <Button
      startIcon={<ArrowLeft width={16} height={16} />}
      variant="contained"
      component={Link}
      to={to}
      {...rest}
      color="secondary"
      sx={{
        backgroundColor: 'rgba(24, 57, 57, 1)',
        borderRadius: 8,

        '&:hover': {
          backgroundColor: 'rgba(24, 57, 57, 1)',
        },
        color: theme => theme.palette.common.white,
        ...rest.sx,
      }}
    >
      {label}
    </Button>
  );
};
